import React, { type FC } from 'react';

import Avatar from '@atlaskit/avatar/avatar';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';

import { ProfileCardWrapper } from '@confluence/profile/entry-points/ProfileCardWrapper.ts';
import type { UserUpdateInfoData } from '@confluence/approvals/entry-points/ApprovalsContext.ts';

export type UserUpdateInfoProps = UserUpdateInfoData;

/**
 * Displays user avatar and name for the content state update metadata.
 * Wraps with ProfileCardWrapper to show profile card on hover.
 * Handles spacing and padding around the avatar.
 *
 * @param displayName - User's display name (required)
 * @param avatarUrl - Optional URL of user's avatar image
 * @param userId - Confluence account ID for profile card hover feature (required)
 */
export const UserUpdateInfo: FC<UserUpdateInfoProps> = ({ avatarUrl, displayName, userId }) => (
	<ProfileCardWrapper userId={userId}>
		<Inline space="space.050" alignBlock="center">
			<Avatar src={avatarUrl} name={displayName} size="xsmall" />
			<Text size="small">{displayName}</Text>
		</Inline>
	</ProfileCardWrapper>
);
